module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/main-view_5a872a96d94240eabbfec102f2844c57.png";